export const colorArr = [
    "#1976d2",
    "#ff5a8f",
    "#ffa600",
    "#7f70d6",
    "#bd66cb",
    "#ec5bb1",
    "#ff6a67",
    "#ff863e",
  ]